import React, { useState } from 'react';
import WorkspaceSettings from './admin/WorkspaceSettings';
import MembersSettings from './admin/MembersSettings';
import EnumSettings from './admin/EnumSettings';
import BillingSettings from './admin/BillingSettings';
import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';
import FormatListBulletedOutlined from '@mui/icons-material/FormatListBulletedOutlined';
import CreditCardOutlined from '@mui/icons-material/CreditCardOutlined';

const SECTIONS = [
  { key: 'workspace', label: 'Workspace',  Icon: BusinessOutlined },
  { key: 'members',   label: 'Members',    Icon: PeopleOutlined },
  { key: 'enums',     label: 'Lists',      Icon: FormatListBulletedOutlined },
  { key: 'billing',   label: 'Billing',    Icon: CreditCardOutlined },
];

const CONTENT = {
  workspace: <WorkspaceSettings />,
  members:   <MembersSettings />,
  enums:     <EnumSettings />,
  billing:   <BillingSettings />,
};

export default function AdminPanel({ isOpen, onClose }) {
  const [activeSection, setActiveSection] = useState('workspace');

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.75)',
        zIndex: 3000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '80vw',
          height: '85vh',
          backgroundColor: '#222222',
          border: '1px solid #3a3a3a',
          borderRadius: '12px',
          boxShadow: '0 32px 80px rgba(0,0,0,0.7), 0 0 80px rgba(57,255,20,0.05)',
          display: 'flex',
          overflow: 'hidden',
        }}
      >
        {/* Sidebar */}
        <div style={{
          width: '200px',
          backgroundColor: '#1a1a1a',
          borderRight: '1px solid #3a3a3a',
          display: 'flex',
          flexDirection: 'column',
          padding: '24px 0 16px 0',
          flexShrink: 0,
        }}>
          <div style={{
            padding: '0 20px 24px 20px',
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 700,
            fontSize: '16px',
            color: '#FFFFFF',
            letterSpacing: '0.5px',
          }}>
            Admin
          </div>

          <div style={{ flex: 1 }}>
            {SECTIONS.map(({ key, label, Icon }) => (
              <SidebarItem
                key={key}
                label={label}
                Icon={Icon}
                isActive={activeSection === key}
                onClick={() => setActiveSection(key)}
              />
            ))}
          </div>
        </div>

        {/* Content area */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          {/* Content header */}
          <div style={{
            padding: '20px 28px',
            borderBottom: '1px solid #3a3a3a',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0,
          }}>
            <span style={{
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 700,
              fontSize: '20px',
              color: '#FFFFFF',
            }}>
              {SECTIONS.find((s) => s.key === activeSection)?.label}
            </span>
            <CloseButton onClick={onClose} />
          </div>

          {/* Scrollable body */}
          <div style={{ flex: 1, overflowY: 'auto', padding: '28px' }}>
            {CONTENT[activeSection]}
          </div>
        </div>
      </div>
    </div>
  );
}

function SidebarItem({ label, Icon, isActive, onClick }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '11px 20px 11px 17px',
        cursor: 'pointer',
        backgroundColor: isActive
          ? 'rgba(57,255,20,0.08)'
          : hovered ? 'rgba(255,255,255,0.04)' : 'transparent',
        borderLeft: `3px solid ${isActive ? '#39FF14' : 'transparent'}`,
        color: isActive ? '#39FF14' : hovered ? '#F5F5F5' : '#888888',
        transition: 'all 0.15s ease',
      }}
    >
      <Icon style={{ fontSize: 18, color: 'inherit' }} />
      <span style={{
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 500,
        fontSize: '14px',
        color: 'inherit',
      }}>
        {label}
      </span>
    </div>
  );
}

function CloseButton({ onClick }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: 'none',
        border: 'none',
        color: hovered ? '#F5F5F5' : '#565656',
        fontSize: '20px',
        cursor: 'pointer',
        lineHeight: 1,
        padding: '0 2px',
        transition: 'color 0.15s ease',
      }}
    >
      ✕
    </button>
  );
}
